<template>
    <form-view class="card-detail-view">
        <div class="detail-content">
            <div class="review-comments" v-if="hasError().designError || hasError().materialError">
                <div v-if="hasError().designError" class="design-comments">
                    <h3>设计审核</h3>
                    <span class="text-danger">未通过</span>
                    <ol class="comments">
                        <li :key="index" v-for="(item, index) in store.formData.reviewComments.designReview">
                            <span class="counter">错误{{index + 1}}：</span>
                            <span class="reason">{{item}}</span>
                        </li>
                    </ol>
                </div>
            <div v-if="hasError().materialError">
                    <h3>物料审核</h3>
                    <span class="text-danger">未通过</span>
                    <ol class="comments">
                        <li :key="index" v-for="(item, index) in store.formData.reviewComments.materialReview">
                            <span class="counter">错误{{index + 1}}：</span>
                            <span class="reason">{{item}}</span>
                        </li>
                    </ol>
                </div>
            </div>
            <div>
                <div class="card-preview">
                    <div class="card-preview-iframe">
                        <h3>{{type}}预览</h3>
                        <div class="iframe-container" :style="styleInfo">
                            <iframe :src="store.formData.preview | https" frameborder="0" />
                        </div>
                    </div>
                    <div v-if="!isPC" class="card-preview-qrcode">
                        <img :src="store.formData.qrCodeUrl" alt="物料预览地址二维码">
                        <p>手机查看</p>
                    </div>
                </div>
                <div class="card-info">
                    <h3>基本信息</h3>
                    <veui-form :data="store.formData">
                        <veui-field label="卡片名称" name="name" field="name">
                            <veui-span>
                                {{store.formData.name}}
                            </veui-span>
                        </veui-field>
                        <veui-field label="广告主名称" name="name" field="name">
                            <veui-span>
                                {{store.formData.aderName}}
                            </veui-span>
                        </veui-field>
                        <veui-field label="广告说明" name="name" field="name">
                            <veui-span>
                                {{store.formData.notes || '-'}}
                            </veui-span>
                        </veui-field>
                    </veui-form>
                </div>
            </div>
        </div>
        <template slot="operation">
            <veui-button @click="goBack">返回</veui-button>
        </template>
    </form-view>
</template>
<script>
import {get} from 'lodash';
import FormView from '@baidu/ve-ria/views/FormView';
import {Form, Field, Span, Button} from 'veui';
import CardDetailModel from './CardDetailModel';
import createView from '@baidu/ve-ria/views/createView';
import cardPreviewMixin from '@/common/mixins/cardPreview';

export default createView(FormView, CardDetailModel, {
    name: 'CardDetailView',
    components: {
        'veui-form': Form,
        'veui-field': Field,
        'veui-span': Span,
        'veui-button': Button
    },
    mixins: [cardPreviewMixin],
    computed: {
        type() {
            return this.store.type === 'frame' ? '中间页' : '卡片';
        }
    },
    methods: {
        hasError() {
            const comments = get(
                this.store,
                'formData.reviewComments',
                {
                    designReview: [],
                    materialReview: []
                }
            );
            return {
                designError: !!comments.designReview.length,
                materialError: !!comments.materialReview.length
            };
        },
        goBack() {
            this.global.redirect({
                url: `/${this.store.type}/list`,
                type: 'push'
            });
        }
    }
});
</script>
<style lang="less">
@import "~@/common/css/variables.less";
.card-detail-view {
    font-size: 14px;

    h3 {
        color: #000;
        font-weight: 700;
    }
    .detail-content {
        padding-top: 16px;
        border-top: 1px solid @muses-gray-2;

        .review-comments {

            width: 362px;
            border-radius: 4px;
            padding: 15px 20px;
            vertical-align: top;
            display: inline-block;
            margin: 0 18px 30px 60px;
            background: @muses-light-yellow;

            h3 {
                display: inline-block;
                margin: 0 15px 10px 0;
            }

            .design-comments {
                margin-bottom: 20px;
            }

            .comments {
                margin: 0;
                padding: 0;
                line-height: 2;
                list-style: none;
                position: relative;

                li {
                    span {
                        display: block;
                    }
                    .counter {
                        float: left;
                    }
                    .reason {
                        overflow: hidden;
                    }
                }

            }
        }

        .card-preview {
            margin-left: 60px;
            display: inline-block;

            .card-preview-iframe {
                display: inline-block;
            }

            .iframe-container {
                padding: 14px;
                display: inline-block;
                border: 1px solid @muses-gray-2;

                iframe {
                    width: 100%;
                    height: 100%;
                }
            }

            .card-preview-qrcode {

                width: 122px;
                margin-top: 35px;
                margin-left: 16px;
                text-align: center;
                vertical-align: top;
                display: inline-block;

                img {
                    width: 100px;
                    height: 100px;
                    padding: 10px;
                    border-radius: 4px;
                    border: 1px solid @muses-gray-2;
                }
                p {
                    padding: 3px 10px;
                    color: @muse-white;
                    border-radius: 11px;
                    display: inline-block;
                    background: @muses-gray-2;
                }
            }
        }
        .card-info {

            vertical-align: top;
            margin-left: 40px;
            display: inline-block;
        }
    }
}
</style>
